export default __webpack_public_path__ + "static/DSC_0006-3c196b0205ec4abc7771dfdbc4feb50d.jpg";